import React, { Component } from "react";
import { MentionsInput, Mention } from "react-mentions";
import defaultStyle from "./defaultStyle";
import defaultMentionStyle from "./defaultMentionStyle";

export default class FieldMentionBox extends Component {
  constructor(props) {
    super(props);
    this.handleEditComment = this.handleEditComment.bind(this);
    this.handleMentionDisplay = this.handleMentionDisplay.bind(this);
  }

  handleEditComment(e, newValue, newPlainTextValue, mentions) {
    const { input } = this.props;

    const { onChange } = input;
    onChange({
      taggingList: mentions,
      comment: newPlainTextValue,
      commentRender: e.target.value,
    });
  }

  handleMentionDisplay = (id, display) => `@${display}`;

  render() {
    const { options, input, ...remainingProps } = this.props;
    const { value } = input;
    const { commentRender } = value;

    return (
      <MentionsInput
        className="mentions-input"
        ref="mentionsInput"
        onChange={this.handleEditComment}
        style={defaultStyle}
        value={commentRender || ""}
        markup="@[__display__](__type__:__id__)"
        placeholder="Add Comment"
        displayTransform={this.handleMentionDisplay}
        label={remainingProps.label}
      >
        <Mention
          type="user"
          trigger="@"
          ref="mention"
          data={options}
          style={defaultMentionStyle}
          appendSpaceOnAdd={false}
        />
      </MentionsInput>
    );
  }
}
